import React, { useState, useEffect, useRef } from "react";
import { Button } from "primereact/button";
import Consts from "../../utilities/Consts";
import StringHelper from "../../utilities/StringHelper";
import CommonHelper from "../../utilities/CommonHelper";
import * as NetworkHelper from "../../utilities/Networkhelper";
import DropDownHelper from "../../utilities/DropDownHelper";
import { useFormik } from "formik";
import { Panel } from "primereact/panel";
import { LkInputText } from "../../components/LkInputText";
import { BlockUI } from "primereact/blockui";
import { LkDropDown } from "../../components/LkDropDown";
import { LkInputTextarea } from "../../components/LkInputTextarea";
import { Toolbar } from "primereact/toolbar";
import { LkCheckbox } from "../../components/LkCheckbox";
import { Divider } from "primereact/divider";

export const AddressItem = (props) => {
  const { } = props;
  const cLabels = Consts.localizedStrings;
  const baseUrl = Consts.network.cus_adress;
  const [errors, setErrors] = useState({});
  const [ddListsys_adres_type, setddListsys_adres_type] = useState([]);
  const [blocked, setBlocked] = useState(false);
  const isFirstRender = useRef(true);
  const formik = useFormik({
    initialValues: {
      id: undefined,
      adres: undefined,
      pk: undefined,
      bolge: undefined,
      sehir: undefined,
      ulke: undefined,
      c_type: undefined,
      a_def: undefined,
      cus_id: props.cus_id,
      note: "",
      sil: 0,
    },

    validateOnChange: false,
    validateOnBlur: true,
    validate: (data) => {
      let errors = {};
      if (StringHelper.isEmpty(data.adres)) {
        errors.adres = cLabels.requiredField;
      }
      if (StringHelper.isEmpty(data.sehir)) {
        errors.sehir = cLabels.requiredField;
      }
      if (StringHelper.isEmpty(data.ulke)) {
        errors.ulke = cLabels.requiredField;
      }
      if (StringHelper.isEmpty(data.c_type)) {
        errors.c_type = cLabels.requiredField;
      }

        setErrors(errors);
    if (Object.keys(errors).length !== 0) {
      CommonHelper.showWarnMessage(cLabels.lutfen_girdiginiz_bigileri_kontrol_ediniz);
    }

      return errors;
    },
    onSubmit: (data) => {
      if (data.id) {
        _update(data);
      } else {
        _create(data);
      }
      
      //formik.resetForm();
    },
  });
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      init();
    }
  });
  const init = async () => {
    setBlocked(true);
    formik.setValues(CommonHelper.replaceJson(formik.values, props.data))
    console.log(props);
    await Promise.all([setddListsys_adres_type(await DropDownHelper.sys_adres_type())]).then((values) => {
      setBlocked(false);
      
    });
    // setSelectedDatatableItem();
    // _onUpdateClicked(formData);
    // setEditItemDiaog(true);
  };

  const _update = async (_formData = formik.values) => {
    
    try {
      setBlocked(true);
      let resp = await NetworkHelper.call_web_service(baseUrl.update, {
        ..._formData,
      });
      props.onCloseSidebar({..._formData,refresh: resp.refresh});
    } catch (error) {
      console.log(error);
      CommonHelper.handleCatch(error);
    } finally {
      setBlocked(false);
    }
  }; //=>end _update
  const _create = async (_formData = formik.values) => {
    
    try {
      setBlocked(true);
      if (StringHelper.isEmpty(props.cus_id)) {
        props.onCloseSidebar(_formData);
      } else {
        let resp = await NetworkHelper.call_web_service(baseUrl.create, {
          ..._formData,
        });
        props.onCloseSidebar({ id: resp.save_response.id, ..._formData ,refresh: resp.refresh});
      }

    } catch (error) {
      console.log(error);
      CommonHelper.handleCatch(error);
    } finally {
      setBlocked(false);
    }
  }; //=>end _create
  const template = (options) => {
    const className = `${options.className} p-jc-start`;
    const titleClassName = `${options.titleClassName} p-pl-1`;

    return (
      <div className={className}>
        <span className={titleClassName}>{cLabels.adres_bilgileri}</span>
        <Button icon="pi pi-times" className="p-button-rounded p-button-danger" onClick={() => {
          props.onCloseSidebar(false);
          CommonHelper.showWarnMessage(cLabels.islem_iptal_edildi)
        }} />
      </div>
    );
  };
  return (
    <Panel headerTemplate={template} toggleable>
      <BlockUI blocked={blocked} fullScreen />
      <form id="address-form" onSubmit={formik.handleSubmit}>
        <div className="grid card">
          <div className="col-12">
            <div className="card">
              <div className="p-fluid p-formgrid grid">
                <div className="p-field col-12">
                  <label >*{cLabels.adres}</label>
                  <LkInputTextarea type="text" rows="2" id="adres" formik={formik} />
                </div>
                <div className="p-field col-12 lg:col-6 md:col-6 sm:col-12">
                  <label >{cLabels.pk}</label>
                  <LkInputText type="text" maxLength="20" id="pk" formik={formik} />
                </div>
                <div className="p-field col-12 lg:col-6 md:col-6 sm:col-12">
                  <label >*{cLabels.sehir}</label>
                  <LkInputText type="text" maxLength="60" id="sehir" formik={formik} />
                </div>
                <div className="p-field col-12 lg:col-6 md:col-6 sm:col-12">
                  <label >{cLabels.bolge}</label>
                  <LkInputText type="text" maxLength="60" id="bolge" formik={formik} />
                </div>
                <div className="p-field col-12 lg:col-6 md:col-6 sm:col-12">
                  <label >*{cLabels.ulke}</label>
                  <LkInputText type="text" maxLength="50" id="ulke" formik={formik} />
                </div>
                <div className="p-field col-12 lg:col-6 md:col-6 sm:col-12">
                  <label >*{cLabels.c_type}</label>
                  <LkDropDown options={ddListsys_adres_type} id="c_type" formik={formik} 
                   _onValueChange={(e) => {
                    if(e.value==4){
                      formik.setFieldValue("a_def", 1);
                      CommonHelper.showSuccessMessage(cLabels.checked_as_default);
                    }else{
                      // formik.setFieldValue("a_def", 0);
                    }
                  }}
                  />
                </div>
                <div className="p-field col-12 lg:col-2 md:col-2 sm:col-12">
                  <label >{cLabels.a_def}</label>
                  <LkCheckbox id="a_def" formik={formik} />
                </div>
                <div className="p-field col-12">
                  <label >{cLabels.note}</label>
                  <LkInputText id="note" type="text" maxLength="250" formik={formik} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Divider />
        <div className="col-12 clear ">
          <Toolbar className="layout-topbar-search" icon="pi pi-check" right={<Button label={Consts.localizedStrings.save} icon="pi pi-check" className="p-button-success p-mr-2" />} />
        </div>
      </form>
    </Panel>
  );
};
